import { Check, Checks, Clock } from "@phosphor-icons/react";
import Avatar from "./Avatar";
import { fmtTime } from "./_format";

// Single chat bubble. Renders mine on the left (RTL justify-end) or the
// other party's on the right, with grouped timestamp + delivery ticks.
// A `_pending` flag on the message (set by the optimistic-send path)
// paints a clock icon + slight opacity to signal "sending…".
export default function Bubble({ msg, mine, showTime, seen, showAvatar, sender }) {
  const pending = mine && !!msg._pending;
  return (
    <div
      className={`flex ${mine ? "justify-end" : "justify-start"} items-end gap-2`}
      data-testid={`msg-${msg.id}`}
    >
      {!mine && showAvatar
        ? <Avatar name={sender?.name} size={28} avatarId={sender?.avatar_id || ""} />
        : !mine ? <div style={{ width: 28 }} /> : null}
      <div className={`max-w-[78%] flex flex-col ${mine ? "items-end" : "items-start"}`}>
        <div
          className={`px-4 py-2 text-[14.5px] leading-relaxed shadow-sm ${
            mine
              ? "bg-gradient-to-bl from-[#10B981] to-[#059669] text-white rounded-[20px] rounded-bl-[6px]"
              : "bg-white text-[#0A192F] border border-[#EAEAEA] rounded-[20px] rounded-br-[6px]"
          } ${pending ? "opacity-80" : ""}`}
        >
          {msg.body && <div className="whitespace-pre-wrap break-words">{msg.body}</div>}
          {msg.attachment?.url && (
            <a
              href={msg.attachment.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block mt-1 text-[12px] underline ${mine ? "text-white/90" : "text-[#B8860B]"}`}
            >
              📎 {msg.attachment.name || "مُرفَق"}
            </a>
          )}
        </div>
        {showTime && (
          <div className={`mt-0.5 flex items-center gap-1 text-[10.5px] px-1 ${mine ? "text-[#5A6470]" : "text-[#8A8A8A]"}`}>
            <span>{fmtTime(msg.created_at)}</span>
            {mine && (pending
              ? <Clock size={12} weight="bold" className="text-[#8A8A8A]" data-testid="msg-pending" />
              : seen
                ? <Checks size={12} weight="bold" className="text-[#10B981]" />
                : <Check size={12} weight="bold" />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
